<template>
    <v-stepper ref="stepper" :items="['Menus', 'Roles', 'Menu Roles']">
        <template v-slot:item.1>
            <v-card class="mb-3">

                <v-card-title class="animate__animated animate__bounceInRight bg-cyan-darken-1 py-3">
                    Registrar Menus
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Nombre" v-model="item_menus.nombre"
                                :error-messages="showFieldsErrors('nombre')" variant="underlined" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Icono" v-model="item_menus.icono"
                                :error-messages="showFieldsErrors('icono')" variant="underlined" />
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Posición" v-model="item_menus.posicion"
                                :error-messages="showFieldsErrors('posicion')" variant="underlined" type="number" />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field color="cyan-darken-1" label="Estado" v-model="item_menus.estado"
                                :error-messages="showFieldsErrors('estado')" variant="underlined" />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field color="cyan-darken-1" label="Submenu" v-model="item_menus.submenu"
                                :error-messages="showFieldsErrors('submenu')" variant="underlined" type="number" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field color="cyan-darken-1" label="Enlace" v-model="item_menus.enlace"
                                :error-messages="showFieldsErrors('enlace')" variant="underlined" />
                        </v-col>

                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" variant="outlined" @click="toClear">
                        <v-icon icon="mdi-delete" />
                    </v-btn>

                    <v-btn color="cyan-darken-1" variant="outlined" @click="saveChild">
                        <v-icon icon="mdi-content-save-outline"></v-icon>&nbsp;Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>

        <template v-slot:item.2>
            <v-card class="mb-3">

                <v-card-title class="animate__animated animate__bounceInRight bg-cyan-darken-1 py-3">
                    Registrar Roles
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Nombre" v-model="item_roles.name"
                                :error-messages="showFieldsErrors('nombre')" variant="underlined" />
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" variant="outlined" @click="toClear">
                        <v-icon icon="mdi-delete" />
                    </v-btn>

                    <v-btn color="cyan-darken-1" variant="outlined" @click="saveChildRoles">
                        <v-icon icon="mdi-content-save-outline"></v-icon>&nbsp;Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>

        <template v-slot:item.3>
            <!-- <FormMenusRoles /> -->
            <v-card class="mb-3">

                <v-card-title class="animate__animated animate__bounceInRight bg-cyan-darken-1 py-3">
                    Registrar Menu Roles
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- <v-col cols="12" sm="6">
                            <v-select v-model="idmenu.menu_id" :items="menus" label="Menus" item-text="nombre"
                                item-value="id" :error-messages="showFieldsErrors('nombre')"
                                variant="underlined"></v-select>
                                
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select v-model="idrole.role_id" :items="roles" label="Roles" item-text="nombre"
                                item-value="id" :error-messages="showFieldsErrors('nombre')"
                                variant="underlined"></v-select>
                                
                        </v-col> -->
                        <v-col cols="12" sm="6">
                            <v-select v-model="idmenurol.menu_id" :items="menus" label="Menus" item-text="nombre"
                                item-value="id" :error-messages="showFieldsErrors('nombre')"
                                variant="underlined"></v-select>
                                
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select v-model="idmenurol.role_id" :items="roles" label="Roles" item-text="nombre"
                                item-value="id" :error-messages="showFieldsErrors('nombre')"
                                variant="underlined"></v-select>
                                
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" variant="outlined" @click="toClear">
                        <v-icon icon="mdi-delete" />
                    </v-btn>

                    <v-btn color="cyan-darken-1" variant="outlined" @click="saveChildMenuRoles">
                        <v-icon icon="mdi-content-save-outline"></v-icon>&nbsp;Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-stepper>
</template>


<script>
import { defineComponent } from 'vue';
import Menus from "@/http/services/Menus";
import Roles from "@/http/services/Roles";
//import FormMenusRoles from '@/components/menus/FormMenuRoles.vue';


export default defineComponent({
    components: {
        //FormMenusRoles,
    },
    props: ['p_item_menus', 'p_fields_errors', 'p_item_roles', 'p_item_menuroles'],
    emits: ['saveParent', 'saverolParent','savemenurolParent', 'isClear'],

    data() {
        const idmenurol =this.p_item_menuroles;
        const menus = [];
        const roles = [];
        const show_password = false;
        const ci = "";
        const change_search_personal = null;
        const item_menus = this.p_item_menus;
        const item_roles = this.p_item_roles;
        return {
            idmenurol,
            menus,
            roles,
            show_password,
            ci,
            change_search_personal,
            item_menus,
            item_roles,
        }
    },//data

    watch: {
        //cuando se modifica los valores de p_item_menus variable del componente padre
        p_item_menus() {
            this.item_menus = this.p_item_menus;
        },
        p_item_roles() {
            this.item_roles = this.p_item_roles;
        },
    },

    computed: {
        showFieldsErrors() {
            return function (property) {
                if (this.p_fields_errors && this.p_fields_errors[property]) {
                    return this.p_fields_errors[property][0];
                }
                return "";
            };

        },
    },
    mounted() {
        this.registros();
    },
    methods: {
        registros() {
            this.change_table = "cyan";
            setTimeout(async () => {
            try {
                const selectServiceMenu = new Menus();
                const response = await selectServiceMenu.selectindex();
                console.log("Estos son los datos del Menu para el select", response);

                const selectServiceRole = new Roles();
                const responseroles = await selectServiceRole.selectroles();
                console.log("Estos son los datos de roles", responseroles);

                if (Array.isArray(response)) {
                    const respuestadatos = response.map(item => `${item.id} - ${item.nombre}`);
                    this.menus = respuestadatos;

                    console.log("datos del select de menus", respuestadatos);
                } else {
                    console.error("Los datos cargados no son un array:", response);
                }


                if (Array.isArray(responseroles)) {
                    const respuestadatosroles = responseroles.map(item => `${item.id} - ${item.name}`);
                    this.roles = respuestadatosroles;

                    console.log("datos del select de roles", respuestadatosroles);
                } else {
                    console.error("Los datos cargados no son un array:", responseroles);
                }


            } catch (error) {
                console.error("Error al obtener la data de menu roles:", error);
            }
        }, 1000);
        },
        saveChild() {
            this.$emit('saveParent', this.item_menus);
            this.$refs.stepper.next();
            this.toClear();
        },
        saveChildRoles() {
            console.log("esto es mi repsuesta oficial",this.item_roles);
            this.$emit('saverolParent', this.item_roles);
            this.$refs.stepper.next();
            this.toClear();
        },
        saveChildMenuRoles() {
            console.log("esto es mi repsuesta oficial",this.idmenurol);
            this.$emit('savemenurolParent', this.idmenurol);
            this.$refs.stepper.next();
            this.toClear();
        },
        toClear() {
            this.$emit('isClear');
        },
    },//methods

});


</script>
